<template>
  <div class="warp">
    <swiper :options="pullSwiperOptions" 
      @transitionStart="onSlideChangeStart"
      @transitionEnd="onSlideChangeEnd"
      @slideChange="onSlideChange"
      ref="fullSwiper">
      <swiper-slide>
        <h1 class="wow animate__animated animate__bounce" data-wow-delay="800ms" data-wow-duration="1.5s">
          <div>第1屏:wowJS滚动动画</div> 
        </h1>
      </swiper-slide>
      <swiper-slide>
        <h1 class="wow animate__animated animate__flip" data-wow-delay="800ms" data-wow-duration="1.5s">
          <div>第2屏:wowJS滚动动画</div> 
        </h1>
      </swiper-slide>
      <swiper-slide>
        <h1 class="wow animate__animated animate__bounceInLeft" data-wow-delay="800ms" data-wow-duration="1.5s">
          第3屏:wowJS滚动动画
        </h1>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { WOW } from "wowjs";
export default {
  name: "swiperHome",
  components: {},
  data() {
    return {
      // 全屏滚动
      pullSwiperOptions: {
        direction: "vertical",
        slidesPerView: 1,
        spaceBetween: 30,
        slidesPerView: 'auto',
        paginationClickable: true,
        keyboardControl: true,
        mousewheelControl: true,
        mousewheel: true,
        // effect : 'fade',
        // fadeEffect: {
        // 	crossFade: true,
        // },
        speed: 1500,
        pagination: {
          el: ".pull-swiper-pagination",
          type: "bullets",
          clickable: true,
          // direction: 'vertical',
        },
        on: {
          slideChange: () => {
            const swiper = this.$refs.fullSwiper.swiper.activeIndex;
            const activeIndex = swiper.activeIndex;
            console.log('当前下标homeSwiperOption：', swiper);

          },
          transitionStart:function(){
            console.log("回调函数transitionStart:",this);

          },
          transitionEnd: (swiper) => {
            console.log("回调函数transitionEnd:",swiper);
          }
        },
      },
    };
  },
  mounted() {
    console.log(window);
    
  },
  methods: {
    wowInit(){
      this.$nextTick(() => {
        let wow=new WOW({
          boxClass: 'wow', // default
          animateClass: 'animated', // default
          offset: -60000, // default
          mobile: true, // default
          live: false,
        
          // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.
        
          callback: function (box) {
            console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
          }
        });
        wow.init();
      });
    },
    
    onSlideChangeStart(swiper, event){
      console.log("onSlideChangeStart:",);
    },
    onSlideChangeEnd(swiper, event) {
      console.log("回调函数onSlideChangeEnd:",swiper, event);
      
    },
    onSlideChange(){
      console.log("回调函数onSlideChange:",);
      this.wowInit();
    },
  },
  destroyed() {

  },
};
</script>
<style>
  html,
  body {
    height: 100% !important;
  }
  #app{
    height: calc(100% - 8rem);
  }
  .warp,.swiper-container,.swiper-wrapper,.swiper-slide{
    width: 100%;
    height: 100%;

  }
  h1{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }
</style>
<style lang="scss" scoped>


</style>